module.exports = __webpack_public_path__ + "img/icon_3_26.dd17d524.png";